var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.02626L10.8445 17.2888C8.5925 19.5705 4.94113 19.5705 2.68905 17.2888C0.436983 15.0072 0.436983 11.3079 2.68905 9.02626L9.4853 2.14082C10.9867 0.619727 13.4209 0.619727 14.9223 2.14082C16.4236 3.66191 16.4236 6.12808 14.9223 7.64917L8.126 14.5346C7.37535 15.2952 6.15824 15.2952 5.40754 14.5346C4.65685 13.7741 4.65685 12.541 5.40754 11.7805L12.2038 4.895",
    stroke: "black",
    strokeOpacity: 0.95,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachpin);
export default __webpack_public_path__ + "static/media/attachpin.73ce0b107ea0bca68e46982bb1e89f7f.svg";
export { ForwardRef as ReactComponent };